import { render, staticRenderFns } from "./outbound-sms-failed-icon.vue?vue&type=template&id=2ca554a2"
import script from "./outbound-sms-failed-icon.vue?vue&type=script&lang=js"
export * from "./outbound-sms-failed-icon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports